/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-plusplus */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import axios, {AxiosResponse} from 'axios'
import {camelizeKeys, decamelize} from 'humps'
import {cloneDeep} from 'lodash'
import md5 from 'md5'

// 开发环境下，webpack 会自动替换成 mock.dev
import {API_PREFIX, API_ROOT} from '../../../config'
import {getCurrentLanguage} from '../../lib/i18n/language'
import isNode from '../../utils/isNode'

// API 响应数据类型定义
interface ApiResponseData {
  ret?: number
  errcode?: number
  msg?: string
  data?: any
  [key: string]: any
}

interface ApiResponse extends AxiosResponse<ApiResponseData> {
  data: ApiResponseData
}

const isObject = (o) => Object.prototype.toString.call(o) === '[object Object]'
const isArray = (o) => Object.prototype.toString.call(o) === '[object Array]'
const decamelizeObj = (data) => {
  const keepRe = /^__\S*?__*/ // 以双下划线开头和结尾的字符，保持不转换，适用于少数特殊情况
  let finalData = data

  if (isObject(data)) {
    finalData = {}
    for (const key in data) {
      let k = decamelize(key)
      if (keepRe.test(key)) {
        k = key.substring(2, key.length - 2)
      }
      let v = data[key]
      if (isObject(v) || isArray(v)) {
        v = decamelizeObj(v)
      }
      finalData[k] = v
    }
  } else if (isArray(data)) {
    finalData = [...data.map((item) => decamelizeObj(item))]
  }

  return finalData
}

const fixApiPath = (path, apiPrefix) => (isNode ? path : `${apiPrefix}${path}`)

// eslint-disable-next-line no-undef
const apiRoot = isNode ? API_ROOT[ENV] : window.location.origin

export const getFinalUrl = (root, path, apiPrefix) => {
  if (root) {
    // 支持 cors 的服务，不需要走 proxy
    return `${root}${path}`
  }

  // 新增，实现了 readme 中的 config 代理方法
  // 这里深拷贝了一下，不知道为什么 client 运行时为什么会变成 undefined,怀疑 commenjs 导出的 obj 在运行时哪里被重新赋值了
  const configObj = cloneDeep(apiPrefix)
  if (isObject(configObj)) {
    const {proxies} = configObj[ENV]
    for (let index = 0; index < proxies.length; index++) {
      const {match, host, map} = proxies[index]
      if (match.test(path)) {
        const realURL = host + map(path)
        // node环境直接打，client 环境走前端 server 的 koa proxy
        const finalUrl = isNode ? realURL : path
        return finalUrl
      }
    }
    // 没匹配到就用配置中的apiPrefix，并使用原有逻辑
    const {apiPrefix} = configObj
    return `${apiRoot}${fixApiPath(path, apiPrefix)}`
  }

  // 保留原有逻辑，问题：node 环境打向了 https://webapi.ixiaochuan.cn，client 环境打向了前段项目 server
  // api.izuiyou.com 和 test.izuiyou.com 的服务需要走 proxy
  return `${apiRoot}${fixApiPath(path, apiPrefix)}`
}

const calcWebSign = (data) => {
  const DEFAULT_SALT = 'YhD6TCs9VpAl'

  const mid = data.h_m
  if (!mid) {
    // eslint-disable-next-line no-console
    console.error('websign arguments error')
    return ''
  }

  const str = JSON.stringify(data) + DEFAULT_SALT
  const len = str.length
  if (len < 20) {
    // eslint-disable-next-line no-console
    console.error('websign length error')
    return ''
  }

  // js 和 Golang 的 unicode 特殊字符字符串截取算法不一样，导致签名不一致，去掉倒序的逻辑。
  // 例如字符串 '12💥Emoji Rule💥'
  // const prefix = str.substring(0, 8)
  // const middle = str.substring(8, len - 8)
  // const postfix = str.substring(len - 8)
  // const mixedStr = middle + postfix + prefix
  return `v2-${md5(`${mid}${md5(str)}`)}`
}

// apiPrefix 可传入 config 的配置 object，具体详见 getFinalUrl
const api =
  (ctx, initMock, apiPrefix = API_PREFIX) =>
  (store) =>
  (next) =>
  (action) => {
    if (!action.api) {
      return next(action)
    }

    if (ENV === 'development' && initMock) {
      initMock(axios)
    }

    const state = store.getState()
    const mid = state.deviceInfo && state.deviceInfo.h_m
    const {isGray} = state.env // 灰度环境标识

    const {
      api: {
        root,
        noZYP = false, // 是否不需要 zyp 签名
        path,
        method = 'post',
        params = {},
        data = {},
        headers = {},
        sign,
      },
      types,
      ...rest
    } = action

    next({
      ...rest,
      type: types.REQUEST,
    })

    const finalData = decamelizeObj({
      ...data,
      hLang: state.deviceInfo?.h_lang || getCurrentLanguage(),
    })

    // 用户名里的特殊字符，导致签名算法验证失败，需要去掉。
    delete finalData.nickname
    return axios({
      method,
      headers: {
        // 添加 x-forwarded-for 字段后，api 那边能识别出触发该 node 端请求对应的客户端 ip 。
        ...['user-agent', 'referer', 'x-forwarded-for', 'cookie'].reduce(
          (acc, headerKey) => {
            const headerValue =
              ctx &&
              ctx.request &&
              ctx.request.headers &&
              ctx.request.headers[headerKey]
            // headers 里设置空值会报错，这里需要判断
            if (headerValue) {
              acc[headerKey] = headerValue
            }
            return acc
          },
          {}
        ),
        'content-type': 'text/plain',
        ...headers,
        // ZYP 头是服务端做白名单控制的。
        // 跨域的请求，如果添加了自定义头，会触发 option 请求。
        ...(root || noZYP ? null : {ZYP: `mid=${mid}`}),
        ...(isGray ? {'X-Xc-Agent': 'gray=on'} : null),
      },
      params: {
        ...params,
        ...(sign && {websign: calcWebSign(finalData)}),
      },
      url: getFinalUrl(root, path, apiPrefix),
      // 当 data 里有特殊 unicode 字符时，如果不转成 string ，服务端计算 sign 的时候，会匹配不上。
      data: sign ? JSON.stringify(finalData) : finalData,
    })
      .then((response: ApiResponse) => {
        const {data: resData} = response
        if (resData.ret <= 0) {
          const err = new Error() as any
          err.response = response
          throw err
        }
        const formatedData = camelizeKeys(resData)
        next({
          ...rest,
          type: types.SUCCESS,
          payload: formatedData,
        })
        return {payload: formatedData}
      })
      .catch((err) => {
        if (!err.request && !err.response) {
          // 非网络和接口的错误（比如 reducer 中的错误）
          throw err
        }
        let msg = ''
        if (!err.response) {
          msg = '网络异常'
        } else if (err.response.status >= 200 && err.response.status < 300) {
          msg =
            (err.response.data &&
              (err.response.data.data
                ? err.response.data.data.msg
                : err.response.data.msg)) ||
            ''
        } else if (err.response.status === 401) {
          msg = 'Unauthorized'
        } else {
          msg = err || '服务器内部错误'
        }
        // eslint-disable-next-line no-console
        console.error('api.js error')
        if (err.response) {
          // eslint-disable-next-line no-console
          console.error(`response data: ${JSON.stringify(err.response.data)}`)
        }
        // eslint-disable-next-line no-console
        console.error(`msg: ${msg}`)
        // eslint-disable-next-line no-console
        console.error(`url: ${getFinalUrl(root, path, '')}`)
        // eslint-disable-next-line no-console
        console.error(
          `request data: ${JSON.stringify(
            sign ? JSON.stringify(finalData) : finalData
          )}`
        )
        next({
          ...rest,
          ...(err.response &&
            err.response.data && {payload: camelizeKeys(err.response.data)}),
          type: types.FAILURE,
        })
        throw new Error(msg)
      })
  }

export default api
export {calcWebSign, decamelizeObj}
